var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AfyButton, AfyModal } from "@affinitysystemsgroup/assurehub-ui";
import { COLLECT_CANCEL_LABEL, COLLECT_CONFIRM_MODAL_MESSAGE, COLLECT_CONFIRM_MODAL_SUBMIT_LABEL, COLLECT_CONFIRM_MODAL_TITLE, } from "../../../constants/collect.constants";
import { ConfirmMessage, ModalActions, ModalTitleText, } from "../style/collectConfirmModal.style";
export var CollectConfirmModalView = function (props) {
    return (_jsxs(AfyModal, __assign({ opened: props.opened, onClose: props.onClose, title: _jsx(ModalTitleText, { children: COLLECT_CONFIRM_MODAL_TITLE }), size: "30%" }, { children: [_jsx(ConfirmMessage, { children: COLLECT_CONFIRM_MODAL_MESSAGE }), _jsxs(ModalActions, { children: [_jsx(AfyButton, { label: COLLECT_CANCEL_LABEL, variant: "default", onClick: props.onClose, disabled: props.loading }), _jsx(AfyButton, { label: COLLECT_CONFIRM_MODAL_SUBMIT_LABEL, color: "brand", onClick: props.onConfirm, loading: props.loading })] })] })));
};
